import React from 'react';
import { PropTypes } from 'prop-types';
import Bugsnag from '@bugsnag/js';
import styled from 'styled-components';

import CircleDangerIcon from '@icons/CircleDangerIcon';
import Circle from '@atoms/Circle';
import { mediaQueries } from '@general/breakpoints';

const ErrorBoundaryBugSnag = Bugsnag.getPlugin('react').createErrorBoundary(React);

const handleError = error => {
    if (typeof Bugsnag !== 'undefined') {
        Bugsnag.notifyException(error);
    }
};

const ErrorStyled = styled.div`
    min-height: 300px;
    height: 100%;
    @media ${mediaQueries.lg} {
        min-height: 600px;
    }
`;

const ErrorFallback = ({ resetErrorBoundary }) => (
    <ErrorStyled className="d-flex justify-content-center flex-column text-center align-items-center py-5">
        <Circle status="error">
            <CircleDangerIcon />
        </Circle>
        <h4 className="mt-2">Sorry, something went wrong.</h4>
        <p style={{ fontSize: '1rem' }}>The error has been reported.</p>
    </ErrorStyled>
);

ErrorFallback.propTypes = {
    resetErrorBoundary: PropTypes.func,
};

const ErrorHandler = ({ children }) => (
    <ErrorBoundaryBugSnag FallbackComponent={ErrorFallback} onError={handleError}>
        {children}
    </ErrorBoundaryBugSnag>
);

ErrorHandler.propTypes = {
    children: PropTypes.any,
};

export default ErrorHandler;
